import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchProductData } from "../services/productService";
import { getCategories, getUnities, getProduct, getstockMove } from "../slices/productSlice";
import { getUsers } from "../slices/userSlice";

const useProducts = () => {
  const dispatch = useDispatch();
  const products = useSelector((state) => state.products.list);
  const categoryData = useSelector((state) => state.products.categories);
  const expiredList = useSelector((state) => state.products.expiredList);
  const stockMoves = useSelector((state) => state.products.stockMove);
  const users = useSelector((state) => state.users.list);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { categories, unities, products, stockMoves, users} = await fetchProductData();
        dispatch(getCategories(categories));
        dispatch(getUnities(unities));
        dispatch(getProduct(products));
        dispatch(getstockMove(stockMoves));
        dispatch(getUsers(users));


      } catch (error) {
        alert(error.message);
      }
    };

    fetchData();
  }, [dispatch]);

  return { products, categoryData , expiredList, stockMoves, users};
};

export default useProducts;
